import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { useProducts, fmt } from "@/lib/api";

export default function SearchOverlay() {
  const { searchOpen, setSearchOpen } = useCart();
  const { products } = useProducts();
  const [q, setQ] = useState("");

  const results = useMemo(() => {
    if (!q.trim()) return [];
    const t = q.toLowerCase();
    return products.filter((p) => `${p.name} ${p.category} ${p.angel} ${p.meaning}`.toLowerCase().includes(t)).slice(0, 8);
  }, [q, products]);

  return (
    <AnimatePresence>
      {searchOpen && (
        <motion.div
          data-testid="search-overlay"
          className="fixed inset-0 z-[85] bg-ink/95 backdrop-blur-md"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <div className="mx-auto max-w-3xl px-5 pt-28 sm:px-8">
            <div className="flex items-center justify-between border-b border-white/20 pb-4">
              <input
                data-testid="search-input"
                autoFocus
                value={q}
                onChange={(e) => setQ(e.target.value)}
                placeholder="SEARCH THE ALIGNMENT…"
                className="w-full bg-transparent font-display text-2xl font-bold uppercase tracking-wide text-bone placeholder:text-bone/30 focus:outline-none sm:text-4xl"
              />
              <button data-testid="search-close" onClick={() => setSearchOpen(false)} aria-label="Close search" className="ml-4 shrink-0 text-bone/60 hover:text-bone">
                <X className="h-6 w-6" />
              </button>
            </div>
            <div className="mt-8">
              {q.trim() === "" ? (
                <p className="font-mono text-[10px] tracking-[0.3em] text-fade">TRY: HOODIE — 111 — PROCESS — CARGO</p>
              ) : results.length === 0 ? (
                <p data-testid="search-no-results" className="font-mono text-[10px] tracking-[0.3em] text-fade">
                  NOTHING FOUND. NO COINCIDENCES — TRY ANOTHER SIGNAL.
                </p>
              ) : (
                results.map((p) => (
                  <Link
                    key={p.id}
                    to={`/product/${p.id}`}
                    onClick={() => setSearchOpen(false)}
                    data-testid={`search-result-${p.id}`}
                    className="flex items-center justify-between border-b border-white/10 py-4 transition-colors hover:bg-white/5"
                  >
                    <div>
                      <p className="font-display text-sm font-bold uppercase text-bone">{p.name}</p>
                      <p className="mt-1 font-mono text-[10px] tracking-widest text-fade">
                        {p.category.toUpperCase()} — {p.angel}
                      </p>
                    </div>
                    <span className="font-mono text-sm text-bone/80">{fmt(p.price)}</span>
                  </Link>
                ))
              )}
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
